












import {Component} from 'vue-property-decorator'
import AdSaveDialog from "@/view/ad-manage/ad/save-dialog.vue";
import {AdCreateForm} from "@/module/ad/AdvertisementApi";

@Component({
  components: {AdSaveDialog}
})
export default class AdCreateDialog extends AdSaveDialog {

  private f = new AdCreateForm()

  private async createAd() {
    await this.api.create(this.f)
  }
}
